var map = {
	"./icon/add.svg": 164,
	"./icon/binoculars.svg": 165,
	"./icon/book-circle-active.svg": 166,
	"./icon/book-circle.svg": 167,
	"./icon/book.svg": 168,
	"./icon/category-core.svg": 169,
	"./icon/category-ignored.svg": 170,
	"./icon/category-interesting.svg": 171,
	"./icon/category-supplementary.svg": 172,
	"./icon/category-unmarked.svg": 173,
	"./icon/chevron_down.svg": 174,
	"./icon/chevron_left.svg": 175,
	"./icon/chevron_right.svg": 176,
	"./icon/chevron_up.svg": 177,
	"./icon/create.svg": 178,
	"./icon/cross.svg": 179,
	"./icon/cross_stroke.svg": 180,
	"./icon/delete.svg": 181,
	"./icon/download.svg": 182,
	"./icon/email.svg": 183,
	"./icon/error.svg": 184,
	"./icon/external.svg": 185,
	"./icon/feedback-active.svg": 186,
	"./icon/feedback.svg": 187,
	"./icon/help-active.svg": 188,
	"./icon/help.svg": 189,
	"./icon/import.svg": 190,
	"./icon/lightbulb.svg": 191,
	"./icon/list.svg": 192,
	"./icon/maximise.svg": 193,
	"./icon/minimize.svg": 194,
	"./icon/minus.svg": 195,
	"./icon/network.svg": 196,
	"./icon/party.svg": 197,
	"./icon/plus.svg": 198,
	"./icon/pucker.svg": 199,
	"./icon/readLater-active.svg": 200,
	"./icon/readLater.svg": 201,
	"./icon/rename.svg": 202,
	"./icon/search.svg": 203,
	"./icon/search@small.svg": 204,
	"./icon/survey.svg": 205,
	"./icon/tick.svg": 206,
	"./icon/tick_stroke.svg": 207,
	"./icon/tutorial.svg": 208,
	"./icon/user.svg": 209,
	"./icon/walkthrough-circle.svg": 210,
	"./icon/walkthrough.svg": 211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;